import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { formatDate, formatHour } from "../../../../core/constants/constants";
import { User } from "../../../../core/icons/User";
import { XCloseGray } from "../../../../core/icons/XClose";

interface ModalOpenImageProps {
	isOpen: boolean;
	infoImage: { picture: string | undefined; username: string | undefined };
	openUrlImage: { urlImage?: string; hourImage: string };
	onClose: () => void;
	children?: React.ReactNode;
}

export const ModalOpenImage: React.FC<ModalOpenImageProps> = ({ isOpen, infoImage, openUrlImage, children, onClose }) => {
	if (!isOpen) return null;

	return (
		<dialog className="z-50 bg-[#000000f5] w-full absolute inset-0 flex-grow h-full flex items-center justify-center">
			<Column
				className="gap-5 rounded-lg flex-grow shadow-lg p-4 h-full relative"
				mainAxisAlignment="center"
				crossAxisAlignment="center"
			>
				{infoImage && (
					<Row className="text-white gap-2 !w-[90%] absolute top-5 left-5">
						{infoImage.picture ? (
							<img
								className="w-12 aspect-square object-cover rounded-full select-none"
								src={infoImage.picture}
								draggable={false}
								alt={`profile-${infoImage.username}`}
							/>
						) : (
							<User className="cursor-pointer bg-gray-200 p-2 text-white w-12 aspect-square object-cover rounded-full"/>
						)}
						<Column mainAxisAlignment="center">
							<TextComponent
								variant="nh5"
								className="font-semibold"
							>
								{infoImage.username}
							</TextComponent>
							<TextComponent
								variant="nh7"
								className="text-primary"
							>
								{formatDate(openUrlImage.hourImage, true)} at {formatHour(openUrlImage.hourImage)}
							</TextComponent>
						</Column>
					</Row>
				)}
				<img
					src={openUrlImage.urlImage}
					alt="Open Message Temp"
					draggable={false}
					className="w-[90%] h-[70%] object-contain select-none"
				/>
				{children}
				<button
					className="absolute top-5 right-5 text-white hover:text-gray-600"
					onClick={onClose}
				>
					<XCloseGray />
				</button>
			</Column>
		</dialog>
	);
};
